{% block sw_cms_block_acris_blog %}
    <div class="sw-cms-block-acris-blog">
        <slot name="column"></slot>
    </div>
{% endblock %}
